import { ServerErrorSection } from '@y2/error-handlers';

import { ErrorLayout } from '../components/error-layout/error-layout';

/**
 * exits to show the user an error page without reporting to sentry like _error
 */
const BadGateway = () => (
  <ErrorLayout>
    <ServerErrorSection subTitle={'502 Bad Gateway'} />
  </ErrorLayout>
);

export default BadGateway;
